import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Encounter
function creatEncounter(params: any) {
    const baseUrl = `/encounter/createEnCounter`;
    return api.create(`${baseUrl}`, params);
}
// update Encounter
function updateEncounter(params: any) {
    const baseUrl = '/encounter/updateEnCounter';
    return api.update(`${baseUrl}`, params);
}

// get all Encounters
function getAllEncounter(params: any) {
    const baseUrl = '/encounter/getEnCounters';
    return api.create(`${baseUrl}`, params);
}

// get patient all Encounters
function getPatientAllEncounter(params: any) {
    const baseUrl = '/encounter/getEnCounterForPatient';
    return api.create(`${baseUrl}`, params);
}

// get Encounter
function getEncounter(params: any) {
    const baseUrl = '/encounter/getEncDtl';
    return api.create(`${baseUrl}`, params);
}

// get Encounter Address
function getEncounterAddress(params: any) {
    const baseUrl = '/encounter/getAddressInfo';
    return api.create(`${baseUrl}`, params);
}

// get Encounter Test
function getEncounterTest(params: any) {
    const baseUrl = '/encounter/getEncRateCard';
    return api.create(`${baseUrl}`, params);
}

// get Discount
function getDiscountValue(params: any) {
    const baseUrl = '/encounter/getDiscountVal';
    return api.create(`${baseUrl}`, params);
}

// add Encounter Test
function addEncounterTest(params: any) {
    const baseUrl = `/encounter/createEncTestInfo`;
    return api.create(`${baseUrl}`, params);
}

// update Encounter Test data
function updateEncounterTestData(params: any) {
    const baseUrl = `/encounter/updateEncTestCharges`;
    return api.create(`${baseUrl}`, params);
}

export {
    creatEncounter,
    updateEncounter,
    getAllEncounter,
    getPatientAllEncounter,
    getEncounter,
    getEncounterAddress,
    getDiscountValue,
    addEncounterTest,
    updateEncounterTestData,
    getEncounterTest,
};
